import { authFetch } from "../../helpers/authFetch";
import { useStreamContext } from "~contexts/Stream";
import { useState } from "react";

interface CronJobHook {
  sendExcelForCronJob: (file: any) => Promise<void>;
  desativarCronJobs: () => Promise<void>;
  refreshCronJobs: () => Promise<void>;
  responseApi: string;
  setResponse: (value: string) => void;
}

const useCronJob: () => CronJobHook = () => {
  const { currentStream, stream } = useStreamContext();
  const [responseApi, setResponse] = useState<string>('');

  const sendExcelForCronJob = async (file: any): Promise<void> => {

    if(process.env.REACT_APP_ENVIRONMENT === 'development') return;
    if (!currentStream) return;

      try {
        const data = file;
        const token = `${JSON.parse(localStorage.getItem("@app:token") || '')}`;
        const form = new FormData();
  
        form.append("token", token);
        form.append("isRerun", JSON.stringify(stream?.video.isRerun));
        form.append("streamname", currentStream.name);
        form.append("xlsxfile", data!);
  
        await authFetch({
          path:`${process.env.REACT_APP_CRON_JOB_URL}/activate-cron-job`,
          method: "POST",
          data: form,
          contentType: "multipart/form-data",
        });
      } catch (error: any) {
        console.error('Erro ao enviar arquivo para o cron job:', error.message || error);
      
    };
          
  };

  const desativarCronJobs = async (): Promise<void> => {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') return;

    try {
      const res = await fetch(`${process.env.REACT_APP_CRON_JOB_URL}/disable-cron-job`, {
        method: 'POST',
      });

      if (!res.ok) throw new Error(`Erro ao desativar o cron job: ${await res.text()}`);

      setResponse('desabled');
    } catch (error: any) {
      console.error('Erro ao desativar o cron job:', error.message || error);
    }
  };

  const refreshCronJobs = async (): Promise<void> => {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') return;

    try {
      const res = await fetch(`${process.env.REACT_APP_CRON_JOB_URL}/update-sheet`, {
        method: 'POST',
      });

      if (!res.ok) throw new Error(`Erro ao atualizar o cron job: ${await res.text()}`);

      setResponse('refresh');
    } catch (error: any) {
      console.error('Erro ao atualizar o cron job:', error.message || error);
    }
  };

  return { sendExcelForCronJob, desativarCronJobs, refreshCronJobs, responseApi, setResponse };
};

export default useCronJob;
